import type { IconSvgObject } from './types';

const MoveRightIcon: IconSvgObject = [
  ["circle", { cx: "5", cy: "12", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 12L12 12M22 12C22 12.562 21.5619 12.9893 20.6857 13.8437L19.0294 15.5001M22 12C22 11.4379 21.5619 11.0107 20.6857 10.1563L19.0296 8.50012", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MoveRightIcon;
